export default "__VITE_PUBLIC_ASSET__67a2d524__"